import { shallowEqual } from 'shared/helpers/utils/shallow-equal';
import type { AppTableColumns, AppTableSingleColumn, AppTableItem } from '../../../ui';
import { isTableColumnGroup } from '../../../ui';

export const getDataIndexedColumns = <TRecord extends AppTableItem>(
  columns: AppTableColumns<TRecord>,
  uniqueDataIndex = false,
): AppTableSingleColumn<TRecord>[] => {
  const result: AppTableSingleColumn<TRecord>[] = [];

  const recursivelyPushSingleColumns = (cols: AppTableColumns<TRecord>) => {
    cols.forEach((col) => {
      if (isTableColumnGroup(col)) {
        recursivelyPushSingleColumns(col.children);
        return;
      }

      if (
        !uniqueDataIndex ||
        !result.some((addedCol) => shallowEqual(addedCol.dataIndex, col.dataIndex))
      ) {
        result.push(col);
      }
    });
  };

  recursivelyPushSingleColumns(columns);

  return result;
};
